import { SelectorOption } from "../../../shared/components/filtering/filter.interfaces";

export interface SelectorOptionsEntity {
  monolithId: number;
  name: string;
}

export class OptionsByIdEntityToModelMapper {
  public map(from: SelectorOptionsEntity): SelectorOption {
    return {
      id: from.monolithId,
      name: from.name,
    };
  }
}
